import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ArrowUpSvg from '../../../assets/icons/app/arrow-up.svg?raw';

export const ArrowUpIcon = (props) => <CustomSVG svg={ArrowUpSvg} preserveColors appIconSmall {...props} />;
